goog.provide("shadow.js.shim.module$$tiptap$extension_underline");
goog.provide("module$shadow_js_shim_module$$tiptap$extension_underline");
shadow.js.shim.module$$tiptap$extension_underline = shadow.js.nativeProvides["@tiptap/extension-underline"] = shadow$bridge("@tiptap/extension-underline");
module$shadow_js_shim_module$$tiptap$extension_underline.default = shadow.js.shim.module$$tiptap$extension_underline;
